import { render, staticRenderFns } from "./AgreementPrivateLabelContentEn.vue?vue&type=template&id=dd6756da&scoped=true"
import script from "./AgreementPrivateLabelContentEn.vue?vue&type=script&lang=js"
export * from "./AgreementPrivateLabelContentEn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6756da",
  null
  
)

export default component.exports